import VoyageComputationState from "./data";

export default function voyageComputationStateFromJson(json) {
    return new VoyageComputationState(
        json.id,
        json.voyage_id,
        json.voyage_theyr_id,
        json.computation,
        json.state_value,
        json.state_title,
        json.progress
    )
}